import { AXNUIFormContentSlotContentTypes } from "@iddataweb/idw-common-ui/enums";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { ResourceCategoryTypes } from "@enums/resource-category-types";
import { SelectOption } from "@idw-types/common";
import { AXNUILayoutHelpTextInner } from "@iddataweb/idw-common-ui/types";
import { ThemingGenericContentSlotValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { ContentSlotCustomHtmlAndCssContainer } from "./content-slot-custom-html-and-css-container/content-slot-custom-html-and-css-container";
import { ContentSlotImageContainer } from "./content-slot-image-container/content-slot-image-container";
import { ContentSlotModalContainer } from "./content-slot-modal-container/content-slot-modal-container";
import { ContentSlotPredefinedFormHelpTextContainer } from "./content-slot-predefined-form-help-text-container/content-slot-predefined-form-help-text-container";
import { ContentSlotExplicitConsentContainer } from "@containers/verification-service-details/verification-service-details-tab-container/verification-service-details-theming-tab/common/generic-content-slot-content-type-container/content-slot-explicit-consent-container/content-slot-explicit-consent-container";

type GenericContentSlotContentTypeContainerProps = {
    formContentSlotType: string;
    contentType: AXNUIFormContentSlotContentTypes;
    resourceCategoryType: ResourceCategoryTypes;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    layout: LayoutTypes;
    validationErrors: ThemingGenericContentSlotValidationErrors;
    predefinedHelpTextTypeOptions: Array<SelectOption>;
    defaultPredefinedFormHelpText: string;
    selectedPredefinedFormHelpText: string;
    defaultValues: AXNUILayoutHelpTextInner;
    values: AXNUILayoutHelpTextInner;
    explicitConsentMessage: string;
    defaultExplicitConsentMessage: string;
    htmlTextVariables: Record<string, string>;
    uploadFileToS3: (file: File, category: ResourceCategoryTypes) => Promise<string>;
    updateAXNUIContentExplicitConsentMessage: (explicitConsentMessage: string) => void;
    updateFormContentSlotContentField: (contentField: AXNUILayoutHelpTextInner, htmlTextVariables?: Record<string, string>) => void;
    updateHtmlTextVariables: (htmlTextVariables: Record<string, string>) => void;
};

export const GenericContentSlotContentTypeContainer = (props: GenericContentSlotContentTypeContainerProps) => {
    const {
        formContentSlotType,
        contentType,
        resourceCategoryType,
        isDisabled,
        labelWidth,
        layout,
        validationErrors,
        predefinedHelpTextTypeOptions,
        defaultPredefinedFormHelpText,
        selectedPredefinedFormHelpText,
        defaultValues,
        values,
        explicitConsentMessage,
        defaultExplicitConsentMessage,
        htmlTextVariables,
        uploadFileToS3,
        updateAXNUIContentExplicitConsentMessage,
        updateFormContentSlotContentField,
        updateHtmlTextVariables
    } = props;

    return (
        <div>
            {contentType === AXNUIFormContentSlotContentTypes.USE_PREDEFINED_FORM_HELP_TEXT && (
                <ContentSlotPredefinedFormHelpTextContainer
                    defaultPredefinedFormHelpText={defaultPredefinedFormHelpText}
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    layout={layout}
                    validationErrors={validationErrors}
                    predefinedHelpTextTypeOptions={predefinedHelpTextTypeOptions}
                    selectedPredefinedFormHelpText={selectedPredefinedFormHelpText}
                    updateFormContentSlotContentField={updateFormContentSlotContentField}
                />
            )}
            {contentType === AXNUIFormContentSlotContentTypes.USE_HTML_CSS && (
                <ContentSlotCustomHtmlAndCssContainer
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    layout={layout}
                    validationErrors={validationErrors}
                    customHtml={values.htmlText}
                    defaultHtml={defaultValues.htmlText}
                    customCss={values.cssContent}
                    defaultCss={defaultValues.cssContent}
                    htmlTextVariables={htmlTextVariables}
                    updateHtmlTextVariables={updateHtmlTextVariables}
                    updateFormContentSlotContentField={updateFormContentSlotContentField}
                />
            )}
            {contentType === AXNUIFormContentSlotContentTypes.USE_IMAGE && (
                <ContentSlotImageContainer
                    formContentSlotType={formContentSlotType}
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    layout={layout}
                    validationErrors={validationErrors}
                    defaultImageAltText={defaultValues.imageAltText}
                    defaultImageHeight={defaultValues.imageHeight}
                    defaultImagePosition={defaultValues.alignImage}
                    defaultImageUrl={defaultValues.imageUrl}
                    defaultImageWidth={defaultValues.imageWidth}
                    imageAltText={values.imageAltText}
                    imageHeight={values.imageHeight}
                    imagePosition={values.alignImage}
                    imageUrl={values.imageUrl}
                    imageWidth={values.imageWidth}
                    resourceCategoryType={resourceCategoryType}
                    uploadFileToS3={uploadFileToS3}
                    updateFormContentSlotContentField={updateFormContentSlotContentField}
                />
            )}
            {contentType === AXNUIFormContentSlotContentTypes.USE_MODAL && (
                <ContentSlotModalContainer
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    layout={layout}
                    validationErrors={validationErrors}
                    defaultLinkText={defaultValues.linkText}
                    defaultModalCssContent={defaultValues.modalCssContent}
                    defaultModalHtmlText={defaultValues.modalHtmlText}
                    linkText={values.linkText}
                    modalCssContent={values.modalCssContent}
                    modalHtmlText={values.modalHtmlText}
                    updateFormContentSlotContentField={updateFormContentSlotContentField}
                />
            )}
            {contentType === AXNUIFormContentSlotContentTypes.USE_EXPLICIT_CONSENT_INPUT && (
                <ContentSlotExplicitConsentContainer
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    layout={layout}
                    validationErrors={validationErrors}
                    explicitConsentMessage={explicitConsentMessage}
                    defaultExplicitConsentMessage={defaultExplicitConsentMessage}
                    updateAXNUIContentExplicitConsentMessage={updateAXNUIContentExplicitConsentMessage}
                />
            )}
        </div>
    );
};